<app-loading [hidden]="!(viewModel.isLoading$ | async)" [options]="viewModel.loadingOpts$ | async" />

<div class="modal-body">
  <app-header header="Upload Profile Picture" i18n-header />
  <app-upload-asset [parentHandler]="this" [allowImage]="true" [allowVideo]="false" [maxAssets]="1" />
  <button
    i18n
    (click)="deleteProfilePicture()"
    *ngIf="viewModel?.existingProfilePicture"
    class="custom-button destructive-button float-left mb-20px">
    Delete Profile Picture
  </button>
  <button
    i18n
    *ngIf="viewModel.file"
    (click)="uploadImage()"
    class="custom-button preferred-button float-right mb-20px">
    Upload
  </button>
  <button i18n (click)="cancel()" class="custom-button neutral-button float-right mb-20px">Cancel</button>
</div>
